import React from 'react';
import { IconButton, classNamesFunction } from '@fluentui/react';
var getClassNames = classNamesFunction();
export var CoherencePanelBodyBase = function (props) {
    var showAccessibleCloseButton = props.showAccessibleCloseButton, closeButtonAriaLabel = props.closeButtonAriaLabel, theme = props.theme, styles = props.styles, onDismiss = props.onDismiss, children = props.children;
    var classNames = getClassNames(styles, { theme: theme });
    return (React.createElement("div", { className: classNames.root },
        children,
        showAccessibleCloseButton && (React.createElement(IconButton, { iconProps: { iconName: 'Cancel' }, className: classNames.accessibleCloseButton, id: "accessible_close_button", "aria-label": closeButtonAriaLabel !== null && closeButtonAriaLabel !== void 0 ? closeButtonAriaLabel : 'Close', onClick: function (e) {
                onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(e);
            } }))));
};
//# sourceMappingURL=CoherencePanelBody.base.js.map